import React, {Fragment} from 'react';
import FlashMessage from "@/Components/FlashMessage";
import {usePage} from "@inertiajs/inertia-react";

export default function Guest({ children, classes = '' }) {
    let flash = usePage().props.flash;

    return (
        <Fragment>
            <div className={`guest ${classes}`}>
                {children}
            </div>
            {flash && loadFlashMessage()}
        </Fragment>
    );

    function loadFlashMessage() {
        return React.createElement(FlashMessage, {...flash})
    }
}
